import $ from 'jquery';
import axios from 'axios';
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["nextArticle"]

  scroll() {
    const body = document.body;
    const html = document.documentElement;
    const height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)

    if(window.pageYOffset >= (height - window.innerHeight) * 0.7) {
      if (this.next && this.next.length) {
        this.fetchNextArticle()
      }
    }
  }

  connect() {
    this.pageInfo =  {
      tags: [],
      ids: []
    }
    this.next = [];

    const options = this.getPageInfo(this.nextArticleTarget)
    if (options.id) this.pageInfo.ids.push(parseInt(options.id));
    if (options.api) this.pageInfo.api = options.api;
    if (options.tags) this.pageInfo.tags = options.tags;
    if (options.limit_num) this.pageInfo.limit_num = parseInt(options.limit_num);

    if (!this.next.length) {
      window.EventManager.emit('fetch_infinite_scroll_article', {
        pageInfo: this.pageInfo
      })
    }

    window.EventManager.on('fetch_infinite_scroll_next_article', data => {
      if (data.next && data.next.length >= 0) {
        const nextArticles =  data.next;
        nextArticles.forEach(article => {
          this.pageInfo.ids = this.pageInfo.ids.concat(article.id)
        })
        this.next = this.next.concat(nextArticles);
        this.fetchNextArticle()
      }
    });
  }

  getPageInfo(obj) {
    return {
      id: obj.dataset.pageinfoId,
      tags: obj.dataset.pageinfoTags,
      api: obj.dataset.pageinfoApi,
      limit_num: obj.dataset.pageinfoLimitNum,
    }
  }

  stop() {
    this.nextArticleTarget.remove();
    return
  }

  fetchNextArticle() {
    if (!this.next.length) {
      window.EventManager.emit('fetch_infinite_scroll_article', { pageInfo: this.pageInfo })
      return;
    }

    if (!this.next) {
      this.stop();
    }

    const page = this.next.shift();
    axios.get(page.path, {
      headers: {
        'Accept': 'application/json'
      }
    }).then(({
      data
    }) => {
      if (data.html_content) {
        const htmlContent = data.html_content.replace(
          new RegExp(/document\.addEventListener\('DOMContentLoaded'/g),
          "window.EventManager.on('infinite-scroll-fetch-success'"
        );
        const execScripts = true;
        const html = $.parseHTML(htmlContent, document, execScripts);
        const $footer = $(this.nextArticleTarget);
        const $container = $('<div/>', {
          id: `article-${page.id}`,
          class: 'content--container__grey'
        }).html(html);
        $footer.before($container);
        window.EventManager.emit('infinite-scroll-fetch-success');
      } else {
        this.stop();
      }
    }).catch(() => {
      this.stop();
    })
  }
}
